<template>
    <div>
        <div class="container height-100 py-2">  
            <div>         
                <custom-initial-calculator-form v-if="$store.state.calculatorState === 'initial'"/>    
                <service-selector v-if="$store.state.calculatorState === 'serviceSelector'"/>   
                <summary-component v-if="$store.state.calculatorState === 'summary'"/>      
            </div>      
        </div>
    </div>
</template>

<script>
import store from "../store";
export default {
    store,
    data: function(){
        return {
            countriesList: {},
            initialLeftText: {},
            renderComponent: true,
            phoneRegex: new RegExp(/[a-zą-ž]/gi),
            requestInProgress: false,
        }
    },
    props: {
        countriesListJson: {
            type: String,
            required: true,
        },
        routesJson: {
            type: String,
            required: true,
        },
        siteSettingsJson: {
            type: String,
            required: true,
        },
        getAllClientsJson: {
            type: String,
            required: true,
        },
        calculatorDataJson: {
            type: String,
            required: false,
            default: '',
        },
    },
    created: function(){
        let vueThis = this;

        if(vueThis.calculatorDataJson !== ''){
            vueThis.$store.state.copied = true;            
            let calculatorData = JSON.parse(Base64.decode(vueThis.calculatorDataJson));  
          
            $.each(calculatorData, function(index, element){
                vueThis.$store.state[index] = structuredClone(element);
            });
        }        

        vueThis.$store.state.countriesList = JSON.parse(Base64.decode(vueThis.countriesListJson));
        vueThis.$store.state.$routes = JSON.parse(Base64.decode(vueThis.routesJson));
        vueThis.$store.state.$siteSettings = JSON.parse(Base64.decode(vueThis.siteSettingsJson));
        vueThis.$store.state.allClients = JSON.parse(Base64.decode(vueThis.getAllClientsJson));
        
        if(!vueThis.$store.state.copied){
            let countrySelected = false;
            $.each(vueThis.$store.state.countriesList, function(index, element){
                if(!countrySelected && element.country_code.toLowerCase() === 'lt'){
                    vueThis.$store.state.from.countryId = index;
                    vueThis.$store.state.from.countryBackgroundImage = element.backgroundImage;
                    vueThis.$store.state.from.countryName = element.title;
    
                    countrySelected = true;
                }
            });      
        }
    },
    methods:{
        getSelectedCountryCities: function(direction) {
            let vueThis = this;
            if(!vueThis.$helper.needsCity()[direction]){
                vueThis.$store.state.computed.citiesArray[direction] = [];
                return;
            }

            let url = vueThis.$store.state.$routes['api.get_cities_for_country'];
            let data = {
                params: {
                    'country_code': vueThis.$store.state[direction].country
                }
            };
            axios.get(url, data)
            .then(function(response){
                if(direction === 'to' && !response.data.includes(vueThis.$store.state.deliveryAddressInformation.city)) {
                    vueThis.$store.state.deliveryAddressInformation.city = '';
                    $('#deliveryCitySelect2').val('').trigger('change.select2');
                } else if(direction === 'from' && !response.data.includes(vueThis.$store.state.shipperAddressInformation.city)){
                    vueThis.$store.state.shipperAddressInformation.city = '';
                    $('#shipperCitySelect2').val('').trigger('change.select2');
                }

                vueThis.$store.state.computed.citiesArray[direction] = response.data;
            }).catch(function(error){
                vueThis.$store.state.computed.citiesArray[direction] = [];
                console.error(error);
            });
        }
    },

    watch: {
        '$store.state.from.postCode': function(){
            this.$store.state.awaitingActions.resetShippings = true;
        },
        '$store.state.to.postCode': function(){
            if (this.$store.state.to.country === 'ma') {
                return;
            }

            this.$store.state.awaitingActions.resetShippings = true;
        },
        '$store.state.awaitingActions.resetShippings': function(){
            if(this.$store.state.awaitingActions.resetShippings === false){
                return;
            }
            this.$store.state.awaitingActions.resetShippings = false;
            
            this.$store.state.availableShippingOptions = [];
            this.$store.state.selectedShippingOption = [];
            this.$store.state.awaitingActions.shippingOptionsWereReset = true;
        }, 
        '$store.state.deliveryAddressInformation.city': function(){
            if(this.$helper.needsCity().to){
                this.$store.state.awaitingActions.resetShippings = true;
            }
        },
        '$store.state.packageType': function(newValue, oldValue){
            if(newValue === '01'){
                this.$store.state.otherDeliveryInformation.isDocuments = 1;
            }
            if (oldValue !== '01') {
                this.$store.state.awaitingActions.resetShippings = true;
            }
            this.$forceUpdate();
        }, 
        '$store.state.from.country': function(){        
            this.$helper.validatePostCode(this.$store.state.from.postCode, this.$store.state.from.country, 'post_code_from');            

            if(this.$store.state.otherDeliveryInformation.isDocuments || this.$helper.insideEu()){
                this.$store.state.otherDeliveryInformation.commercialInvoiceType = '';
            }
            this.getSelectedCountryCities('from');
        },
        '$store.state.to.country': function(){         
            this.$helper.validatePostCode(this.$store.state.to.postCode, this.$store.state.to.country, 'post_code_to');            

            if(this.$store.state.otherDeliveryInformation.isDocuments || this.$helper.insideEu()){
                this.$store.state.otherDeliveryInformation.commercialInvoiceType = '';
            }  
            this.getSelectedCountryCities('to');
        },
    },
}
</script>
